import { SvgIcon } from '@mui/material'

// Types
import { SvgIconProps } from '@mui/material'

const DesignToolIconAtom = (props: SvgIconProps) => {
	return (
		<SvgIcon {...props} viewBox="0 0 51 51">
			<path
				fill="none"
				stroke="currentColor"
				strokeWidth={5}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M22.1637 37.4425C22.1637 39.78 21.2712 42.0112 19.5925 43.7112C18.2962 45.0075 16.5325 45.9 14.4287 46.1762L9.20122 46.75C6.35372 47.0687 3.90997 44.6462 4.24997 41.7562L4.82372 36.5287C5.33372 31.875 9.22247 28.9 13.345 28.815C13.77 28.7937 14.2162 28.815 14.62 28.8362C16.4262 29.07 18.19 29.8987 19.635 31.365C21.0587 32.7887 21.8662 34.4462 22.1 36.2312C22.1212 36.635 22.1637 37.0387 22.1637 37.4425Z"
			/>

			<g opacity={0.4}>
				<path
					fill="none"
					stroke="currentColor"
					strokeWidth={5}
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M46.3453 8.37224C43.0728 16.5322 34.8703 27.6247 28.0065 33.1285L23.8203 36.486C23.289 36.8685 22.7578 37.2085 22.1628 37.4422C22.1628 37.0597 22.1415 36.6347 22.0778 36.231C21.844 34.446 21.0365 32.7885 19.6128 31.3647C18.1678 29.9197 16.404 29.0697 14.5978 28.836C14.1728 28.8147 13.7478 28.7722 13.3228 28.8147C13.5565 28.156 13.9178 27.5397 14.364 27.0297L17.679 22.8435C23.1615 15.9797 34.2965 7.73474 42.4353 4.48349C43.689 4.01599 44.9003 4.35599 45.6653 5.14224C46.4728 5.92849 46.8553 7.13974 46.3453 8.37224Z"
				/>

				<path
					fill="none"
					stroke="currentColor"
					strokeWidth={5}
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M30.2595 30.7492C30.2595 25.203 25.7545 20.698 20.2083 20.698"
				/>

				<path
					fill="none"
					stroke="currentColor"
					strokeWidth={5}
					strokeLinecap="round"
					d="M42.755 27.0512L44.3275 28.6025C47.4938 31.7687 47.4938 34.8925 44.3275 38.0587L38.0375 44.3487C34.9138 47.4725 31.7475 47.4725 28.6238 44.3487"
				/>

				<path
					fill="none"
					stroke="currentColor"
					strokeWidth={5}
					strokeLinecap="round"
					d="M6.60868 22.3338C3.48493 19.1675 3.48493 16.0438 6.60868 12.8775L12.8987 6.5875C16.0224 3.46375 19.1887 3.46375 22.3124 6.5875L23.8849 8.16"
				/>

				<path fill="none" stroke="currentColor" strokeWidth={5} strokeLinecap="round" d="M23.9062 8.18124L16.0437 16.0437" />
				<path fill="none" stroke="currentColor" strokeWidth={5} strokeLinecap="round" d="M42.7551 27.0512L36.4651 33.32" />
			</g>
		</SvgIcon>
	)
}

export default DesignToolIconAtom
